import { gql } from '@apollo/client'

export const GET_PAIRING_DATA = gql`
  query lspayPairings($registerID: ID) {
    lspayPairings(registerID: $registerID) {
      registerID
      deviceLabel
      deviceSN
      deviceType
      deviceID
      pli
      appVersion
    }
  }
`
